import * as Yup from 'yup';

export const fixedPrice = Yup.number().when('category', {
  is: value => value !== 2,
  then: Yup.number()
    .required()
    .positive(),
});
